var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-4"},[_vm._v(" "+_vm._s(_vm.data.title)+" ")]),_vm._l((_vm.data.faqs),function(faq){return _c('FaqItem',{key:faq.id,attrs:{"question":faq.question,"answer":faq.answer}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }